module.exports = __webpack_public_path__ + "img/loginLogo.2b8270e8.png";